import { AutomationChannel } from "@redotech/redo-model/advanced-flow/common";
import { SchemaType } from "@redotech/redo-model/advanced-flow/schemas/schemas";
import type { AiContextLibrary } from "@redotech/redo-model/ai-context-library";
import {
  AiContextLibrarySchema,
  AiContextLibraryType,
} from "@redotech/redo-model/ai-context-library";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

const AutomationChannelValues = [
  AutomationChannel.Email,
  AutomationChannel.SMS,
] as const;

const SchemaTypeValues = Object.values(SchemaType) as [
  SchemaType,
  ...SchemaType[],
];

export const getContextLibraryItemsByScenario = {
  name: "getContextLibraryItemsByScenario" as const,
  input: z.object({
    type: z.literal(AiContextLibraryType.MARKETING),
    triggerType: createEnum(SchemaTypeValues),
    scenarioType: z.string(),
    channel: createEnum(AutomationChannelValues),
  }),
  output: z.object({
    items: z.array(AiContextLibrarySchema as z.ZodType<AiContextLibrary>),
  }),
};
